import { Image } from '@busybusy/webapp-react-ui';
import {
  HighwayIcon1,
  HighwayIcon10,
  HighwayIcon11,
  HighwayIcon12,
  HighwayIcon13,
  HighwayIcon14,
  HighwayIcon2,
  HighwayIcon3,
  HighwayIcon4,
  HighwayIcon5,
  HighwayIcon6,
  HighwayIcon7,
  HighwayIcon8,
  HighwayIcon9,
} from 'assets/equipment-icons/highway';
import './EquipmentIconRenders.scss';

export interface IHighwayIconsProps {
  onClick: (icon: string) => void;
}

const HighwayIcons = (props: IHighwayIconsProps) => {
  const { onClick } = props;

  const icons = [
    HighwayIcon1,
    HighwayIcon2,
    HighwayIcon3,
    HighwayIcon4,
    HighwayIcon5,
    HighwayIcon6,
    HighwayIcon7,
    HighwayIcon8,
    HighwayIcon9,
    HighwayIcon10,
    HighwayIcon11,
    HighwayIcon12,
    HighwayIcon13,
    HighwayIcon14,
  ];

  return (
    <div className="icon-list mt-2">
      {icons.map((icon, index) => (
        <Image src={icon} key={index} className={'selectable-icon'} onClick={() => onClick(icon)} />
      ))}
    </div>
  );
};

export default HighwayIcons;
